import createTestId, { getTestId } from "../../../../fabrics/createTestId";

const HEADER_SCHEVRON_PREFIX = "header-schevron";

export const HEADER_SCHEVRON_TEST_ID = getTestId(HEADER_SCHEVRON_PREFIX);

export const createTestIdForHeaderSchevron = createTestId(
    HEADER_SCHEVRON_PREFIX,
);
